import { render, staticRenderFns } from "./FlowForm.vue?vue&type=template&id=d4c2bea8&scoped=true&"
import script from "./FlowForm.vue?vue&type=script&lang=js&"
export * from "./FlowForm.vue?vue&type=script&lang=js&"
import style0 from "./FlowForm.vue?vue&type=style&index=0&id=d4c2bea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c2bea8",
  null
  
)

export default component.exports